import React from 'react';
export function CustomerInfo({
  customer,
  setCustomer
}) {
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setCustomer(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="mb-8" data-id="element-36" data-mp="2wk274c3yy9cg">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-37" data-mp="2wj99c0mzmu6g">
        Customer Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-38" data-mp="2rlqyg4peu4vt">
        <div data-id="element-39" data-mp="3p6mznfw6krhl">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40" data-mp="3p6dafuiymocy">
            Name <span className="text-red-500" data-id="element-41" data-mp="3k8bsxe16mx3l">*</span>
          </label>
          <input type="text" name="name" value={customer.name} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-42" data-mp="3fhvbliu8qrby" />
        </div>
        <div data-id="element-43" data-mp="bttlnej2fll1">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-44" data-mp="buctu3iwyvlv">
            Email <span className="text-red-500" data-id="element-45" data-mp="710i2tzc2jaj">*</span>
          </label>
          <input type="email" name="email" value={customer.email} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-46" data-mp="ktd0s8i01p65" />
        </div>
        <div data-id="element-47" data-mp="b2s2yna5gooa">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-48" data-mp="b31kdmh4pnid">
            Phone <span className="text-red-500" data-id="element-49" data-mp="g13a2q928l2t">*</span>
          </label>
          <input type="tel" name="phone" value={customer.phone} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-50" data-mp="14lz404s98gs" />
        </div>
        <div data-id="element-51" data-mp="3obo3ojndbx8v">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-52" data-mp="3obwjokesfioa">
            State <span className="text-red-500" data-id="element-53" data-mp="3t9g3dzu98nnm">*</span>
          </label>
          <input type="text" name="state" value={customer.state} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" required data-id="element-54" data-mp="1mi6vnevbsudl" />
        </div>
        <div className="md:col-span-2" data-id="element-55" data-mp="1p0s6m1d9x9ye">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-56" data-mp="1l0ruwohk7cv1">
            Shipping Address (Optional)
          </label>
          <input type="text" name="address" value={customer.address} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-57" data-mp="1g2zroybgs4bj" />
        </div>
        <div data-id="element-58" data-mp="28syjh1h1mfjw">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59" data-mp="28sowlmraooif">
            City (Optional)
          </label>
          <input type="text" name="city" value={customer.city} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-60" data-mp="1z0j2a6dklv02" />
        </div>
        <div data-id="element-61" data-mp="2rieyetth6aju">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-62" data-mp="2ri56v1ss7vc1">
            ZIP Code (Optional)
          </label>
          <input type="text" name="zip" value={customer.zip} onChange={handleChange} className="border rounded-md px-3 py-2 w-full" data-id="element-63" data-mp="2mok5czrzcj83" />
        </div>
      </div>
    </div>;
}